"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var PercentageStackArea = /** @class */ (function (_super) {
    tslib_1.__extends(PercentageStackArea, _super);
    function PercentageStackArea() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PercentageStackArea.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'percentageStackArea';
        _super.prototype.createLayers.call(this, layerProps);
    };
    PercentageStackArea.getDefaultOptions = layer_1.default.getDefaultOptions;
    return PercentageStackArea;
}(plot_1.default));
exports.default = PercentageStackArea;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/percentage-stack-area/index.js
// module id = 939
// module chunks = 37